<template>
    <div class="client-status-table">
        <div class="alert alert-danger text-center font-bold" v-if="columns > 12">{{ t_broken }}</div>

        <table class="table table-striped table-bordered dataTable dtr-inline" aria-label="systemlog table">
            <thead>
                <tr>
                    <th v-for="header in table_head" :class="[sort_column === header ? sort_direction : '']"
                        @click.stop.prevent="sort(header)"
                        :style="(is_contenttype(header) || is_duration(header) || is_repeats(header)) ? 'text-align: center;' : ''">
                        {{ header }}
                        <span v-if="sort_column === header && sort_direction === 'asc'" class="sort-asc"></span>
                        <span v-else-if="sort_column === header && sort_direction  === 'desc'" class="sort-desc"></span>
                        <span v-else class="sort-alt"></span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in table_data">
                    <td v-for="header in table_head" :class="'reporting-data'"
                        :title="(is_filename(header) || is_comment(header)) ? (row[header]['data'] || '-') : ''"
                        :style="(is_contenttype(header) || is_duration(header) || is_repeats(header)) ? 'text-align: center;' : ''"
                        v-html="row[header]['data'] || '-'">
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="row cs-row text-center text-danger" v-if="loading === true">
            <h3 class="no-margins p-sm"><i class="fa-regular fa-spinner fa-spin"></i></h3>
        </div>
        <div class="row cs-row text-center text-danger" v-if="table_data.length === 0 && loading === false">
            <h3 class="no-margins p-sm">{{ t_no_result_data }}</h3>
        </div>
        <div class="row cs-row text-center" v-if="loading === false">
            <reporting-list-pagination
                :page="page"
                :pages="pages"
                event="updateReportingList">
            </reporting-list-pagination>
        </div>
    </div>
</template>
<script>
    import debounce from 'debounce';
    import toaster from "../common/toaster";
    import {dateISOToDateUS, dateTodayUS, dateUSToDateISO, localizeDate} from "../../../utils/date";

    export default {
        components: {
            reportingListPagination: require('./client-detail/pagination.vue').default,
        },
        props: [
            'from',
            'to',
            'filter_from',
            'filter_to',
            'search',
            'groups',
            'locations'
        ],
        data() {
            return {
                t_load_error: Lang.langGet("Failed to load table."),
                t_no_result_data: Lang.langGet("No results with current filter."),
                t_broken: Lang.langGet("WARNING! You have selected more than 12 columns. This is NOT recommended because the rows look broken now!"),
                table_head: [],
                table_data: [],
                columns: 1,
                sort_column: '',
                sort_direction: '',
                filter_id: -1,
                column_id: -1,
                limit: 50,
                page: 0,
                pages: 0,
                loading: false,
            }
        },
        methods: {
            load: debounce(function (mode) {
                if (typeof mode === 'undefined') {
                    this.table_data = [];
                }

                this.loading = true;
                var _from = this.from;
                var _to = this.to;
                if ((this.to=='')&&(this.filter_to=='')) {
                    _to = dateTodayUS();
                }
                if ((this.from=='')&&(this.filter_from=='')) {
                    const subOneWeekDate = new Date(_to);
                    subOneWeekDate.setDate(subOneWeekDate.getDate() - 7);
                    _from = dateISOToDateUS(subOneWeekDate.toISOString().substring(0, 10));
                }
                axios.post('/system/reporting/list-table', {
                    project_id: Laravel.activeProject,
                    filter_id: this.filter_id,
                    column_id: this.column_id,
                    search:    this.search,
                    groups:    this.groups,
                    locations: this.locations,
                    date_from: _from,
                    date_to: _to,
                    mode: mode,
                    sort_column: this.sort_column,
                    sort_direction: this.sort_direction,
                    limit: this.limit,
                    page: this.page,
                }).then((response) => {
                    if (typeof response.data.data !== 'string') {
                        this.table_head = response.data.data.header;
                        this.table_data = response.data.data.data;
                        this.columns = response.data.data.columns;
                        this.pages = response.data.data.pages

                        this.$nextTick(() => {
                            $(this.$el).find('[data-featherlight="image"]').featherlight();
                        });
                        this.loading = false;
                    } else {
                        EaseEventBus.fire('downloadModeDone');
                        window.location = response.data.data;
                    }
                }).catch((error) => {
                    this.loading = false;
                    EaseEventBus.fire('downloadModeDone');

                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_error);
                });
            }, 500),
            sort: function (column) {
                if (this.sort_column === column) {
                    if (this.sort_direction === 'asc') {
                        this.sort_direction = 'desc';
                    } else {
                        this.sort_direction = 'asc';
                    }
                } else {
                    this.sort_column = column;
                    if (this.is_date(column) || this.is_duration(column) || this.is_repeats(column)) {
                        this.sort_direction = 'desc';
                    } else {
                        this.sort_direction = 'asc';
                    }
                }

                this.page = 0;
                this.load();
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            },
            col: function (header) {
                let calculatedColumns = Math.floor(12 / parseInt(this.columns));
                if (this.is_filename(header)) {
                    calculatedColumns = Math.max(1, 12 - this.columns);
                }

                if (calculatedColumns < 1) {
                    calculatedColumns = 1;
                }
                return calculatedColumns;
            },
            is_filename: function (header) {
                return header === Lang.langGet('File Name');
            },
            is_comment: function (header) {
                return header === Lang.langGet('Comment');
            },
            is_contenttype: function (header) {
                return header === Lang.langGet('Content Type');
            },
            is_duration: function (header) {
                return header === Lang.langGet('Duration');
            },
            is_repeats: function (header) {
                return header === Lang.langGet('Repeats');
            },
            is_date: function (header) {
                return header === Lang.langGet('Date');
            }
        },
        computed: {
        },
        mounted() {
            EaseEventBus.listen('updateTable', (data) => {
                this.page = 0;

                if (data == null) {
                    this.reset();
                } else {
                    if (data.filter!==null) {
                        this.filter_id = data.filter;
                    }
                    if (data.column!==null) {
                        this.column_id = data.column;
                    }
                    this.load();
                }
            });

            EaseEventBus.listen('downloadMode', (mode) => {
                this.load(mode);
            });

            EaseEventBus.listen('updateReportingList', (page) => {
                this.page = page;
                this.load();
            });
        }
    }
</script>
<style scoped>
.sort-asc:after {
    font-family: "Font Awesome 6 Pro" !important;
    content: '\f161' !important;
    opacity: 0.6 !important;
}

.sort-desc:after {
    font-family: "Font Awesome 6 Pro" !important;
    content: '\f160' !important;
    opacity: 0.6 !important;
}

.sort-alt:after {
    font-family: "Font Awesome 6 Pro" !important;
    content: '\e099' !important;
    opacity: 0.125 !important;
}

.table {
    thead {
        height: 50px;

        tr th {
            vertical-align: middle !important;
        }
    }

    tbody tr {
        height: 50px;

        td {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
